var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowNawBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    viewBox: "0 0 12 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.501964 10.5035C0.500506 10.1177 0.646949 9.7315 0.941293 9.43716L9.43433 0.944127C10.0201 0.358341 10.9699 0.358341 11.5556 0.944127C12.1414 1.52991 12.1414 2.47966 11.5556 3.06545L4.12207 10.499L11.5585 17.9354C12.1443 18.5212 12.1443 19.471 11.5585 20.0568C10.9727 20.6425 10.0229 20.6425 9.43716 20.0568L0.941297 11.5609C0.649242 11.2688 0.502799 10.8863 0.501964 10.5035Z",
    fill: "#8293AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNawBig);
export default __webpack_public_path__ + "static/media/arrow-naw-big.020255e1bb262edd5b92b66600884c4d.svg";
export { ForwardRef as ReactComponent };